import React from 'react';
import { handleExportToExcel as exportToExcel } from './utils/exportUtils';
import useGroupedWorklogs from './hooks/useGroupedWorklogs';
import useSortedGroups from './hooks/useSortedGroups';
import TableHeaderControls from './TableHeaderControls';
import UngroupedView from './views/UngroupedView';
import IssueGroupedView from './views/IssueGroupedView';
import GeneralGroupedView from './views/GeneralGroupedView';

const TimeTrackingTable = ({
  filteredWorkLogs,
  grouping,
  sorting,
  hasLoadedData,
  onToggleGroupExpansion,
  onGroupingChange,
  onSortingChange
}) => {
  // Use custom hooks for grouping and sorting
  const groupedWorkLogs = useGroupedWorklogs(filteredWorkLogs, grouping.field);
  const sortedGroupedWorkLogs = useSortedGroups(
    groupedWorkLogs,
    sorting,
    grouping.field,
    filteredWorkLogs
  );

  const handleExportToExcel = () => {
    exportToExcel(grouping.field, sortedGroupedWorkLogs, filteredWorkLogs);
  };

  const headerControls = (
    <TableHeaderControls
      grouping={grouping}
      sorting={sorting}
      onGroupingChange={onGroupingChange}
      onSortingChange={onSortingChange}
      onExport={handleExportToExcel}
    />
  );

  if (!hasLoadedData) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-8 text-center">
        <div className="text-gray-500 dark:text-slate-400">
          <div className="text-lg font-medium mb-2 dark:text-slate-200">No Data Loaded</div>
          <p className="text-sm">Apply filters to load worklog data</p>
        </div>
      </div>
    );
  }

  // Render different views based on grouping type
  let viewComponent;
  if (grouping.field === 'none') {
    viewComponent = (
      <UngroupedView
        worklogs={filteredWorkLogs}
        headerControls={headerControls}
      />
    );
  } else if (grouping.field === 'issue') {
    viewComponent = (
      <IssueGroupedView
        groupedWorkLogs={sortedGroupedWorkLogs}
        grouping={grouping}
        onToggleGroupExpansion={onToggleGroupExpansion}
        headerControls={headerControls}
      />
    );
  } else {
    viewComponent = (
      <GeneralGroupedView
        groupedWorkLogs={sortedGroupedWorkLogs}
        grouping={grouping}
        filteredWorkLogs={filteredWorkLogs}
        onToggleGroupExpansion={onToggleGroupExpansion}
        headerControls={headerControls}
      />
    );
  }

  return viewComponent;
};

export default TimeTrackingTable;
